export default __webpack_public_path__ + "static/media/fellowship.135b076e.jpg";